module.exports = __webpack_public_path__ + "static/sdk-giphy-text-e04439076e58a1d69ace670a14e51b07.gif";